export interface Tome {
  title: string
  description: string
  pages: number
}

export const tomes: Tome[] = [
  { title: 'Écouter, chanter et jouer', description: 'Premiers jeux d’écoute, voix et rythmes.', pages: 60 },
  { title: 'Le rythme en mouvement', description: 'Pulsation, coordination et jeux rythmiques.', pages: 60 },
  {
    title: 'La voix et les premières mélodies',
    description: 'Explorer la voix et construire des repères mélodiques.',
    pages: 60,
  },
  {
    title: 'Jouer ensemble et lire des repères musicaux',
    description: 'Pratique collective et premières lectures musicales.',
    pages: 60,
  },
  {
    title: 'Créer et partager un projet musical',
    description: 'Organiser une création et la présenter.',
    pages: 60,
  },
  {
    title: 'Construire une pratique musicale collective',
    description: 'Répéter, coopérer et ajuster le jeu du groupe.',
    pages: 60,
  },
  {
    title: 'Écouter, comparer et argumenter',
    description: 'Décrire ses écoutes et expliquer ses choix.',
    pages: 60,
  },
  {
    title: 'Composer, arranger et expérimenter',
    description: 'Transformer des idées musicales et essayer différentes versions.',
    pages: 60,
  },
  {
    title: 'Musique, images et cultures',
    description: 'Explorer les liens entre musique, images et contextes culturels.',
    pages: 60,
  },
  {
    title: 'Concevoir et présenter un projet musical autonome',
    description: 'Planifier, réaliser et évaluer un projet.',
    pages: 60,
  },
]
